import isPostalCode from 'validator/lib/isPostalCode';
import isLength from 'validator/lib/isLength';
import isURL from 'validator/lib/isURL';
import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isNumeric from 'validator/lib/isNumeric';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isAlphanumeric from 'validator/lib/isAlphanumeric';
import matches from 'validator/lib/matches';
import { isPossibleNumber } from 'libphonenumber-js';
import {
  CONTACT_FIELDS_MAX_LENGTH,
  NAMES_MIN_LENGTH,
  LOCALE_NL,
  INPUT_MAX_LENGTH,
  INPUT_MIN_LENGTH,
  KVK_MAX_LENGTH,
  COMPANY_NAME_WEBSITE_MAX_LENGTH,
  LOCALE_EN_US,
  INPUT_USER_NAME_MAX_LENGTH,
} from '../constants/constants';

export const validatePostCode = (value: string) => isPostalCode(value, LOCALE_NL);

export const validateAddressMinLength = (value: string) => value.length >= NAMES_MIN_LENGTH;

export const validateAddressMaxLength = (value: string) => value.length <= CONTACT_FIELDS_MAX_LENGTH;

export const validateHouseNumber = (value: string) =>
  isLength(value, { min: INPUT_MIN_LENGTH, max: CONTACT_FIELDS_MAX_LENGTH });

export const validateWebsite = (value: string) =>
  (isURL(value) && value.length <= COMPANY_NAME_WEBSITE_MAX_LENGTH) || isEmpty(value);

export const validateEmail = (value: string) => isEmail(value);

export const validatePhone = (value: string) => isPossibleNumber(value, LOCALE_NL);

export const validateNameMinLength = (value: string) => value.length >= NAMES_MIN_LENGTH;

export const validateNameMaxLength = (value: string) => value.length <= CONTACT_FIELDS_MAX_LENGTH;

export const validateKvk = (value: string) => isNumeric(value) || isEmpty(value);

export const validateKvkLength = (value: string) => value.length === KVK_MAX_LENGTH || isEmpty(value);

export const validatePromoCode = (value: string) =>
  isLength(value, { min: INPUT_MIN_LENGTH, max: INPUT_MAX_LENGTH }) || isEmpty(value);

// EBS has strict rules for company name - for example, it doesn't accept single quotes symbol
export const validateCompanyNameAccordingToEBSRules = (value: string) =>
  isAlphanumeric(value, LOCALE_EN_US, { ignore: ' -_.äöüÄÖÜß' });

export const validateCompanyNameMaxLength = (value: string) => value.length <= COMPANY_NAME_WEBSITE_MAX_LENGTH;

export const validateTaxNumber = (value: string) => matches(value, /^NL\d{9}B\d{2}$/) || isEmpty(value);

export const validateUserName = (value: string) => !isEmail(value) && !isURL(value);

export const validateUserNameMaxLength = (value: string) => value.length <= INPUT_USER_NAME_MAX_LENGTH;

export const validatePassword = (value: string) => isStrongPassword(value);

export const validateRepeatPassword = (value: string, password: string) => value === password;
